export default {
  dev: false, // true = dev ; false = prod
};
